// extracted by mini-css-extract-plugin
module.exports = {"container":"_cb9541e6","itemContainer":"_f21fd853","imageWrapper":"_8eddd095","title":"_f8640ec1","image":"_48299ec6","shimmerLoadingBackground":"_9502fdcc"};